/**
 * Activates deferred product media: the server renders a poster button and an
 * inert template holding the player markup; clicking the poster swaps the
 * template content in. Iframes and video players never load before intent.
 */
class DeferredMedia extends HTMLElement {
  connectedCallback() {
    const poster = this.querySelector('[data-deferred-poster]');
    const template = this.querySelector('[data-deferred-template]');
    if (!poster || !template) return;
    poster.addEventListener(
      'click',
      () => {
        poster.replaceWith(template.content.cloneNode(true));
        this.querySelector('video')
          ?.play?.()
          .catch(() => {});
      },
      { once: true },
    );
  }
}

customElements.define('deferred-media', DeferredMedia);
